/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React, { type JSX } from 'react'

// ratio は 横 / 縦
export type RatioImageProps = Omit<JSX.IntrinsicElements['img'], 'css'> & {
  ratio: number
}

export const RatioImage = ({ ratio, ...props }: RatioImageProps) => {
  const paddingBottom = `calc(${1 / ratio} * 100%)`

  const ratioImageStyle = css`
    position: relative;
    &::before {
      height: 0px;
      content: '';
      display: block;
      padding-bottom: ${paddingBottom};
    }
    & > img {
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }
  `

  return (
    <div css={ratioImageStyle}>
      <img {...props} />
    </div>
  )
}
